import React from "react"

const SettingsTab = props => {
  const { id, first_name, last_name, company, phone, email } = props.customer
  const [fields, setFields] = React.useState({
    id,
    first_name,
    last_name,
    company,
    phone,
    email,
    password: "",
    confirmPassword: "",
    currentPassword: "",
  })
  const [msg, setMsg] = React.useState(null)
  const [isSubmit, setIsSubmit] = React.useState(false)

  function handleChange({ target }) {
    setFields(prev => ({ ...prev, [target.name]: target.value }))
  }

  async function handleSubmit(e) {
    e.preventDefault()

    let payload = {
      id: fields.id,
      first_name: fields.first_name,
      last_name: fields.last_name,
      company: fields.company,
      phone: fields.phone,
      email: fields.email,
    }

    setMsg(null)
    setIsSubmit(true)
    props?.setCustomerErr(false)

    const { password, confirmPassword, currentPassword } = fields

    if (password || confirmPassword || currentPassword) {
      if (!password) {
        setMsg({ isError: true, msg: "Please enter password." })
        setIsSubmit(false)
        return
      }

      if (!confirmPassword) {
        setMsg({ isError: true, msg: "Please enter confirm password." })
        setIsSubmit(false)
        return
      }

      if (!currentPassword) {
        setMsg({ isError: true, msg: "Please enter current password." })
        setIsSubmit(false)
        return
      }

      if (password !== confirmPassword) {
        setMsg({ isError: true, msg: "Mismatch password." })
        setIsSubmit(false)
        return
      }

      const validate = await fetch(
        `/.netlify/functions/bigcommerce?endpoint=/v3/customers/validate-credentials`,
        {
          credentials: "same-origin",
          mode: "same-origin",
          method: "POST",
          body: JSON.stringify({
            email: fields.email,
            password: fields.currentPassword,
          }),
        }
      )

      if (validate.status === 200) {
        const response = await validate.json()
        if (!response?.is_valid) {
          setMsg({ isError: true, msg: "Incorrect current password." })
          setIsSubmit(false)
          return
        }

        payload.authentication = {
          force_password_reset: false,
          new_password: fields.password,
        }
      }
    }

    await props.updateCustomer([payload])
    if (!props?.customerErr) {
      setMsg({ isError: false, msg: "Successfully update." })
    }
    setIsSubmit(false)
  }

  return (
    <div className="w-100 m-auto pt-3" style={{ maxWidth: 700 }}>
      {msg?.msg && (
        <div
          className={`mb-3 alert ${
            msg.isError ? "alert-danger" : "alert-success"
          }`}
          role="alert"
        >
          {msg.msg}
        </div>
      )}

      {props?.customerErr.length && (
        <div className={`mb-3 alert alert-danger`} role="alert">
          <ul>
            {props.customerErr.map((err, i) => (
              <li key={i}>{err}</li>
            ))}
          </ul>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-row mb-3">
          <div className="col-md-6">
            <div className="form">
              <input
                type="text"
                className="form__input"
                name="first_name"
                id="first_name"
                placeholder=" "
                value={fields?.first_name || ""}
                onChange={handleChange}
                required
              />
              <label htmlFor="first_name" className="form__label">
                First Name
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form">
              <input
                type="text"
                className="form__input"
                name="last_name"
                id="last_name"
                placeholder=" "
                value={fields?.last_name || ""}
                onChange={handleChange}
                required
              />
              <label htmlFor="last_name" className="form__label">
                Last Name
              </label>
            </div>
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-md-6">
            <div className="form">
              <input
                type="text"
                className="form__input"
                name="company"
                id="company"
                placeholder=" "
                value={fields?.company || ""}
                onChange={handleChange}
              />
              <label htmlFor="company" className="form__label">
                Company
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form">
              <input
                type="text"
                className="form__input"
                name="phone"
                id="phone"
                placeholder=" "
                value={fields?.phone || ""}
                onChange={handleChange}
              />
              <label htmlFor="phone" className="form__label">
                Phone Number
              </label>
            </div>
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-md-6">
            <div className="form">
              <input
                type="email"
                className="form__input"
                name="email"
                id="email"
                placeholder=" "
                value={fields?.email || ""}
                onChange={handleChange}
                required
              />
              <label htmlFor="email" className="form__label">
                Email Address
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form">
              <input
                type="password"
                className="form__input"
                name="password"
                id="password"
                placeholder=" "
                value={fields?.password || ""}
                onChange={handleChange}
              />
              <label htmlFor="password" className="form__label">
                Password
              </label>
            </div>
          </div>
        </div>

        <div className="form-row mb-3">
          <div className="col-md-6">
            <div className="form">
              <input
                type="password"
                className="form__input"
                name="confirmPassword"
                id="confirmPassword"
                placeholder=" "
                value={fields?.confirmPassword || ""}
                onChange={handleChange}
              />
              <label htmlFor="confirmPassword" className="form__label">
                Comfirm Password
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form">
              <input
                type="password"
                className="form__input"
                name="currentPassword"
                id="currentPassword"
                placeholder=" "
                value={fields?.currentPassword || ""}
                onChange={handleChange}
              />
              <label htmlFor="currentPassword" className="form__label">
                Current Password
              </label>
            </div>
          </div>
        </div>

        <div className="text-center">
          <button
            type="submit"
            className="btn btn-dark text-uppercase"
            disabled={isSubmit}
          >
            {isSubmit ? "loading.." : "update details"}
          </button>
        </div>
      </form>
    </div>
  )
}

export default SettingsTab
